import { Component, Output, EventEmitter } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { BzgModalService, BzgToastService, BzgToastType, PageEvent } from 'bz-genome-angular';
import { ShowToastService } from 'app/shared/services/showToast.service';
import { DetailConfirmQueueitemsModalComponent } from '../../../common-components/modals/detail-confirm-queueitems-modal/detail-confirm-queueitems-modal.component';
import {
  DetailQueueitemsModalComponent
} from '../../../common-components/modals/detail-queueitems-modal/detail-queueitems-modal.component';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from 'i18n/i18n.service';

import {
  UIPathRetryQueueitemSelector,
  getUIPathQueueitemsListSelector
} from '../../../store/selectors/rpa-uipath-dashboard.selector';

import {
  getUIPathCurrentConnector
} from '../../../store/selectors/rpa-uipath-conn.selector';
import { IAppState } from 'app/IAppState';
import { IQueueItem } from 'app/rpa-bots/uipath/common/models/IQueueItem';
import { IRpaConnectionUiPath } from 'app/rpa-bots/core/IRpaBots';

@Component({
  selector: 'biz-uipath-queueitem-retries',
  templateUrl: './uipath-queueitem-retries.component.html',
  styleUrls: ['./uipath-queueitem-retries.component.scss']
})
export class UipathQueueitemRetriesComponent {
  dataQueueitems: IQueueItem[];
  dataQueueitems$: Observable<IODataResponse<IQueueItem[]>>;
  @Output() retryQueueitem = new EventEmitter<any>();
  @Output() resetQueueitem = new EventEmitter<any>();

  headers: string[];
  uiPathConnection$: Observable<IRpaConnectionUiPath>;
  items: any[];
  pageSize = 10;
  pageIndex = 0;
  totalItems: number;
  showFirstLastButtons = true;
  hidePageSizeSelector = false;
  event: PageEvent;
  queueitemRetried$: Observable<any>;
  dataQueueitemSubscriber: any;
  queueitemRetriedSubscriber: any;
  uiPathConnectionSubscriber: any;

  private currentUiPathConnection: IRpaConnectionUiPath;
  private _userModalSubscription: Subscription;

  constructor(
    private _translateService: TranslateService,
    private _toastService: BzgToastService,
    private _modalService: BzgModalService,
    private _store: Store<IAppState>,
    private _i18nService: I18nService,
    private _showToastService: ShowToastService
  ) {
    this._translateService
      .get([
        'RPA_BOTS.DETAIL',
        'RPA_BOTS.QUEUE_NAME',
        'RPA_BOTS.STATUS',
        'RPA_BOTS.REFERENCE',
        'RPA_BOTS.PRIORITY',
        'RPA_BOTS.CREATION_TIME',
        'RPA_BOTS.EXCEPTION',
        'RPA_BOTS.RETRY'
      ])
      .subscribe((data: any) => {
        this.headers = [
          data['RPA_BOTS.DETAIL'],
          data['RPA_BOTS.QUEUE_NAME'],
          data['RPA_BOTS.STATUS'],
          data['RPA_BOTS.REFERENCE'],
          data['RPA_BOTS.PRIORITY'],
          data['RPA_BOTS.CREATION_TIME'],
          data['RPA_BOTS.EXCEPTION'],
          data['RPA_BOTS.RETRY']
        ];
      });
    this.uiPathConnection$ = this._store.pipe(
      select(getUIPathCurrentConnector)
    );
    this.uiPathConnectionSubscriber = this.uiPathConnection$.subscribe(
      uiPathConnection => (this.currentUiPathConnection = uiPathConnection)
    );

    this.queueitemRetried$ = this._store.pipe(
      select(UIPathRetryQueueitemSelector)
    );

    this.dataQueueitems$ = this._store.pipe(
      select(getUIPathQueueitemsListSelector)
    );

    this.dataQueueitemSubscriber = this.dataQueueitems$.subscribe(response => {
      if (response) {
        this.dataQueueitems = response.value || [];
        this.totalItems = this.dataQueueitems.length;
        this.items = this.items = this.dataQueueitems.slice(
          this.pageSize * this.pageIndex,
          this.pageSize * this.pageIndex + this.pageSize <
            this.dataQueueitems.length
            ? this.pageSize * this.pageIndex + this.pageSize
            : this.dataQueueitems.length
        );
      } else {
        this.dataQueueitems = [];
      }
    });

    this.queueitemRetriedSubscriber = this.queueitemRetried$.subscribe(
      queueitemId => {
        if (queueitemId !== null) {
          this._translateService
            .get('RPA_BOTS.QUEUE_ITEM_ID_RETRY', { queueItemId: queueitemId })
            .subscribe((message: string) => {
              this._showToastService.showToast(message, 'success');
            });
          this.resetQueueitem.emit();
        }
      }
    );
  }

  ngOnDestroy() {
    if (this.queueitemRetriedSubscriber) {
      this.queueitemRetriedSubscriber.unsubscribe();
    }

    if (this.uiPathConnectionSubscriber) {
      this.uiPathConnectionSubscriber.unsubscribe();
    }

    if (this.dataQueueitemSubscriber) {
      this.dataQueueitemSubscriber.unsubscribe();
    }
  }

  openConfirmModal(queueItem: IQueueItem) {
    const modalRef = this._modalService.open(
      DetailConfirmQueueitemsModalComponent,
      {
        closeOnBackdropClick: false,
        closeOnRouterNavigation: true,
        closeOnEscape: false,
        data: queueItem
      }
    );

    this._userModalSubscription = modalRef
      .afterClosed()
      .subscribe(async (queueitem: any) => {
        if (queueitem && queueitem.Id) {
          this.retryQueueitem.emit(queueitem);
        }
      });
  }

  openDetailModal(queueItem: IQueueItem) {
    const modalRef = this._modalService.open(DetailQueueitemsModalComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
      closeOnEscape: false,
      data: queueItem
    });

    this._userModalSubscription = modalRef
      .afterClosed()
      .subscribe(async (modalData: any) => { });
  }

  onPaginationEvent(event: PageEvent) {
    this.event = event;
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.totalItems = event.totalItems;

    if (this.dataQueueitems) {
      this.items = this.dataQueueitems.slice(
        this.pageSize * this.pageIndex,
        this.pageSize * this.pageIndex + this.pageSize <
          this.dataQueueitems.length
          ? this.pageSize * this.pageIndex + this.pageSize
          : this.dataQueueitems.length
      );
    }
  }
}
